import { either, noop } from '@cd/utils';
import * as R from 'ramda';

/** handleResponse :: { fn = noop, dispatch, queryClient, queryName : string | [] } -> either -> string|error */
export const handleMutationResponse = R.curry(
	(
		{
			successFn = noop,
			errorFn = noop,
			dispatch,
			queryClient,
			queryName,
			formRef
		},
		r
	) => {
		return either(
			e => {
				dispatch({ type: 'post error', e });
				errorFn(e);
				return e;
			},
			d => {
				if (R.is(String, d)) {
					dispatch({
						type: 'post success',
						message: d
					});
				}
				if (queryName) {
					R.compose(
						R.map(name => queryClient.invalidateQueries(name)),
						R.when(R.is(String), R.of)
					)(queryName);
				}

				successFn(d, formRef.current);
				return d;
			},
			r
		);
	}
);
